export const getRelatedSliderOptions = (slider) => {
  return {
    navigation: {
      nextEl: slider.parentElement.querySelector(
        ".b-related_articles-nav.m-next"
      ),
      prevEl: slider.parentElement.querySelector(
        ".b-related_articles-nav.m-prev"
      ),
    },
    slidesPerView: 1,
    breakpoints: {
      // !!! if you need change these breakpoints or options values, please look through to the blocks/blog-hub/src/style.scss - the class .b-blog_hub-list shoud have the same styles

      550: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
    },
  };
};
